import qs from "qs";
import React, { useLayoutEffect, useMemo } from "react";
import { Pagination } from "@pd/pd-ui-kit";
import { useTranslation } from "react-i18next";

import FilterMetric from "~/pages/Editor/EditorDealerMetric/FilterMetric";
import { useDealersMetric } from "~/entity/Dealer/hooks/useDealersMetric";
import { useGetLocationData, useSetLocationData } from "~/hooks/locationData";
import {
  DealerMetricTableRow,
  getDealerMetricColumns,
} from "~/pages/Editor/EditorDealerMetric/model/tableAdapter";
import { FILTER_BY } from "~/pages/Staff/assets/StaffFilter/lib";
import { usePaginationParams } from "~/shared/hooks/usePaginationParams";
import { TableV2 } from "~/shared/ui/TableV2";

import s from "~/pages/Editor/EditorDealerMetric/styles.less";

const parseUrlList = (raw: unknown): string[] =>
  raw ? String(raw).split(",").filter(Boolean) : [];

const DealerMetric = () => {
  const { page, count } = useGetLocationData();
  const setData = useSetLocationData();
  const { t } = useTranslation();

  // Ключи фильтра приходят из URL и не описаны в типе useGetLocationData
  const { filterBy, filterItems, period } = useGetLocationData() as Record<
    string,
    unknown
  >;

  // Query-строка запроса метрик — из URL-фильтра (раньше собиралась
  // buildDealerGroupQuery из состояния формы FilterMetric)
  const queryParams = useMemo(() => {
    const dealerGroup = {
      ids: [] as number[],
      cities: [] as string[],
      FOs: [] as string[],
      countries: [] as string[],
      subjects: [] as string[],
    };

    const values = parseUrlList(filterItems);
    if (filterBy && values.length) {
      switch (filterBy) {
        case FILTER_BY.CITY:
          dealerGroup.cities = values;
          break;
        case FILTER_BY.FO:
          dealerGroup.FOs = values;
          break;
        case FILTER_BY.AREA:
          dealerGroup.subjects = values;
          break;
        case FILTER_BY.COUNTRY:
          dealerGroup.countries = values;
          break;
        case FILTER_BY.DEALER:
          dealerGroup.ids = values.map(Number);
          break;
      }
    }

    return qs.stringify(
      {
        dealerGroup,
        actualOn: period
          ? String(period)
          : new Date().toISOString().split("T")[0],
      },
      { allowEmptyArrays: true },
    );
  }, [filterBy, filterItems, period]);

  const { data, isLoading } = useDealersMetric({
    filter: queryParams,
    page: page.toString(),
    count: count.toString(),
    type: "main",
  });

  useLayoutEffect(() => {
    setData("page", "0", "count", "25");
  }, []);

  const { handleCount, handlePage } = usePaginationParams();

  return (
    <div className={s.wrapper}>
      <FilterMetric />
      <TableV2<DealerMetricTableRow>
        wrapperClassName={s.tableWrapper}
        columns={getDealerMetricColumns(t)}
        dataSource={(data?.formatData ?? []) as DealerMetricTableRow[]}
        loading={isLoading}
        rowKey="dealerId"
      />
      <Pagination
        count={count}
        page={page + 1}
        totalCount={data?.totalCount ?? 0}
        onChangeCount={handleCount}
        onChangePage={handlePage}
      />
    </div>
  );
};

export default DealerMetric;
